export const displayError = (container, stripeContainer, message) => {
    const existingError   = container.querySelector('.stripe-error');
    if (existingError) {
        existingError.remove();
    }

    const errorElement         = document.createElement('div');
    errorElement.className     = 'stripe-error invalid-feedback';
    errorElement.style.display = 'block';
    errorElement.textContent   = message;

    stripeContainer.insertAdjacentElement('afterend', errorElement);
};
